module.exports = __webpack_public_path__ + "static/image/logo-t.5a5a9fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-t.png
// module id = 376
// module chunks = 1